import React from 'react';

import { Condition } from 'components/condition-list/SearchFilter';
import { NOTICE_TYPE_KEY } from 'stores/NoticeAdminStoreAdapter';

import NoticeManagementPage from './NoticeManagement';

/**
 * お知らせ（INFO）管理ページ
 * フィルター: タイトル, 期限あり, 作成日FROM, 作成日TO
 * ※ INFOは全員向けなのでユーザーID検索は不要
 */
const AdminNoticeInfoPage: React.FC = () => {
  return <NoticeManagementPage noticeType={NOTICE_TYPE_KEY.INFO} conditions={conditions} />;
};

const conditions: Condition[] = [
  {
    key: 'titleKeyword',
    name: 'タイトル',
    type: 'text',
    color: '#3A98B9',
  },
  {
    key: 'hasDeadline',
    name: '期限あり',
    type: 'check',
    color: '#F97B22',
    value: { key: 'true', name: '期限あり' },
  },
  {
    key: 'createdAtFrom',
    name: '作成日FROM',
    type: 'date-time-picker-start',
    color: '#B799FF',
  },
  {
    key: 'createdAtTo',
    name: '作成日TO',
    type: 'date-time-picker-end',
    color: '#B799FF',
  },
];

export default AdminNoticeInfoPage;
